module.exports = __webpack_public_path__ + "media/images/landing-page-d893feaf.png";